import React from 'react';
import PropTypes from 'prop-types';
import { constants } from '@wsb/guac-widget-core';
import Placeholder from './Placeholder';
import { Loading } from './index';
import { EMPTY } from '../constants/viewStates';

const {
  renderModes: { EDIT }
} = constants;

function ViewState(props) {
  const { staticContent, viewState, renderMode } = props;
  const { addPodcastUrl, comingSoon } = staticContent;

  if (viewState === EMPTY) {
    return <Placeholder message={ renderMode === EDIT ? addPodcastUrl : comingSoon } />;
  }

  return <Loading />;
}

ViewState.propTypes = {
  staticContent: PropTypes.object,
  viewState: PropTypes.string,
  renderMode: PropTypes.string
};

export default ViewState;
